export enum RowAction {
    CLICK,
    EDIT,
    DELETE,
    CHECKED,
    UNCHECKED,
    CREATE,
    AUTOCOMPLETE_FILTER
}

export type TableAction = RowAction | ToolBarActions

export enum ToolBarActions {
    ADD_NEW,
}
